import { STATE_VERSION } from "@gearbox-protocol/sdk/onchain";

export const EVENT_SIGNIN = "auth_signin";
export const EVENT_SIGNOUT = "auth_signout";
export const STATE_CACHE_URL_BASE = `https://state-cache.gearbox.foundation/v${STATE_VERSION}`;
